(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("47P9U", function(module, exports) {

$parcel$export(module.exports, "listen", function () { return $a60817e649179cb4$export$63174c828edd6ff8; });
function $a60817e649179cb4$var$e(e) {
    return new Promise(function(n, r, t) {
        (t = new XMLHttpRequest).open("GET", e, t.withCredentials = !0), t.onload = function() {
            200 === t.status ? n() : r();
        }, t.send();
    });
}
var $a60817e649179cb4$var$n, $a60817e649179cb4$var$r = ($a60817e649179cb4$var$n = document.createElement("link")).relList && $a60817e649179cb4$var$n.relList.supports && $a60817e649179cb4$var$n.relList.supports("prefetch") ? function(e) {
    return new Promise(function(n, r, t) {
        (t = document.createElement("link")).rel = "prefetch", t.href = e, t.onload = n, t.onerror = r, document.head.appendChild(t);
    });
} : $a60817e649179cb4$var$e, $a60817e649179cb4$var$t = window.requestIdleCallback || function(e) {
    var n = Date.now();
    return setTimeout(function() {
        e({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - n));
            }
        });
    }, 1);
}, $a60817e649179cb4$var$o = new Set, $a60817e649179cb4$var$i = new Set, $a60817e649179cb4$var$c = !1;
function $a60817e649179cb4$var$a(e) {
    if (e) {
        if (e.saveData) return new Error("Save-Data is enabled");
        if (/2g/.test(e.effectiveType)) return new Error("network conditions are poor");
    }
    return !0;
}
function $a60817e649179cb4$export$63174c828edd6ff8(e) {
    if (e || (e = {}), window.IntersectionObserver) {
        var n = function(e) {
            e = e || 1;
            var n = [], r = 0;
            function t() {
                r < e && n.length > 0 && (n.shift()(), r++);
            }
            return [
                function(e) {
                    n.push(e) > 1 || t();
                },
                function() {
                    r--, t();
                }
            ];
        }(e.throttle || 1 / 0), r = n[0], a = n[1], u = e.limit || 1 / 0, l = e.origins || [
            location.hostname
        ], d = e.ignores || [], h = e.delay || 0, p = [], m = e.timeoutFn || $a60817e649179cb4$var$t, w = "function" == typeof e.hrefFn && e.hrefFn, g = e.prerender || !1;
        $a60817e649179cb4$var$c = e.prerenderAndPrefetch || !1;
        var v = new IntersectionObserver(function(n) {
            n.forEach(function(n) {
                if (n.isIntersecting) p.push((n = n.target).href), function(e, n) {
                    n ? setTimeout(e, n) : e();
                }(function() {
                    -1 !== p.indexOf(n.href) && (v.unobserve(n), ($a60817e649179cb4$var$c || g) && $a60817e649179cb4$var$i.size < 1 ? $a60817e649179cb4$export$4f10e897d13fb72b(w ? w(n) : n.href).catch(function(n) {
                        if (!e.onError) throw n;
                        e.onError(n);
                    }) : $a60817e649179cb4$var$o.size < u && !g && r(function() {
                        $a60817e649179cb4$export$f003ab04b0b3c00e(w ? w(n) : n.href, e.priority).then(a).catch(function(n) {
                            a(), e.onError && e.onError(n);
                        });
                    }));
                }, h);
                else {
                    var t = p.indexOf((n = n.target).href);
                    t > -1 && p.splice(t);
                }
            });
        }, {
            threshold: e.threshold || 0
        });
        return m(function() {
            (e.el || document).querySelectorAll("a").forEach(function(e) {
                l.length && !l.includes(e.hostname) || function e(n, r) {
                    return Array.isArray(r) ? r.some(function(r) {
                        return e(n, r);
                    }) : (r.test || r).call(r, n.href, n);
                }(e, d) || v.observe(e);
            });
        }, {
            timeout: e.timeout || 2e3
        }), function() {
            $a60817e649179cb4$var$o.clear(), v.disconnect();
        };
    }
}
function $a60817e649179cb4$export$f003ab04b0b3c00e(n, t, u) {
    var s = $a60817e649179cb4$var$a(navigator.connection);
    return s instanceof Error ? Promise.reject(new Error("Cannot prefetch, " + s.message)) : ($a60817e649179cb4$var$i.size > 0 && !$a60817e649179cb4$var$c && console.warn("[Warning] You are using both prefetching and prerendering on the same document"), Promise.all([].concat(n).map(function(n) {
        if (!$a60817e649179cb4$var$o.has(n)) return $a60817e649179cb4$var$o.add(n), (t ? function(n) {
            return window.fetch ? fetch(n, {
                credentials: "include"
            }) : $a60817e649179cb4$var$e(n);
        } : $a60817e649179cb4$var$r)(new URL(n, location.href).toString());
    })));
}
function $a60817e649179cb4$export$4f10e897d13fb72b(e, n) {
    var r = $a60817e649179cb4$var$a(navigator.connection);
    if (r instanceof Error) return Promise.reject(new Error("Cannot prerender, " + r.message));
    if (!HTMLScriptElement.supports("speculationrules")) return $a60817e649179cb4$export$f003ab04b0b3c00e(e), Promise.reject(new Error("This browser does not support the speculation rules API. Falling back to prefetch."));
    if (document.querySelector('script[type="speculationrules"]')) return Promise.reject(new Error("Speculation Rules is already defined and cannot be altered."));
    for(var t = 0, u = [].concat(e); t < u.length; t += 1){
        var f = u[t];
        if (window.location.origin !== new URL(f, window.location.href).origin) return Promise.reject(new Error("Only same origin URLs are allowed: " + f));
        $a60817e649179cb4$var$i.add(f);
    }
    $a60817e649179cb4$var$o.size > 0 && !$a60817e649179cb4$var$c && console.warn("[Warning] You are using both prefetching and prerendering on the same document");
    var l = function(e) {
        var n = document.createElement("script");
        n.type = "speculationrules", n.text = '{"prerender":[{"source": "list","urls": ["' + Array.from(e).join('","') + '"]}]}';
        try {
            document.head.appendChild(n);
        } catch (e) {
            return e;
        }
        return !0;
    }($a60817e649179cb4$var$i);
    return !0 === l ? Promise.resolve() : Promise.reject(l);
}

});


var $47P9U = parcelRequire("47P9U");
window.addEventListener('load', (e)=>{
    (0, $47P9U.listen)({
        ignores: [
            (uri)=>uri.includes('#'),
            (uri)=>uri.includes('.pdf'),
            (uri)=>uri.includes('.doc'),
            (uri)=>uri.includes('docx'),
            (uri)=>uri.includes('xls'),
            (uri)=>uri.includes('xlsx'),
            (uri)=>uri.includes('mp3'),
            (uri)=>uri.includes('wav'),
            (uri)=>uri.includes('zip'),
            (uri)=>uri.includes('odt'),
            (uri)=>uri.includes('odf'),
            (uri)=>uri.includes('ods'),
            (uri, elem)=>elem.hasAttribute('noprefetch')
        ]
    });
});

})();
//# sourceMappingURL=quicklink.js.map
